import ImageCard from "./ImageCard";
import { highlight } from "./utils";

export default function StepCard({ step, q }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-5 gap-4 md:gap-6">
      <div className="md:col-span-3">
        <h4 className="font-semibold text-slate-900 dark:text-white">
          {highlight(step.title, q)}
        </h4>
        <p className="text-slate-600 dark:text-slate-300 mt-1">
          {highlight(step.text, q)}
        </p>
      </div>
      <div className="md:col-span-2">
        <ImageCard
          src={step.img}
          alt={step.title}
          caption="Touchez pour agrandir"
          onClick={step.onImageClick}
        />
      </div>
    </div>
  );
}
